import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'
import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { ApiTags } from './tags'

/* @TODO: Probably should move away from `axios` for RTKQ requests */
const axiosBaseQuery =
    (): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
        },
        unknown,
        unknown
    > =>
    async ({ url, method, data, params }) => {
        try {
            const result = await axios({ url, method, data, params })
            return { data: result.data }
        } catch (axiosError) {
            const errorResponse = axiosError as AxiosError['response']

            return { error: errorResponse }
        }
    }

export const apiSlice = createApi({
    baseQuery: axiosBaseQuery(),
    endpoints: () => ({}),
    reducerPath: 'api-slice',
    tagTypes: Object.values(ApiTags),
})
